import { useEffect } from "react";

type DemoPopupProps = {
  data: {
    id: string;
    text: string;
    href: string;
  }[];
};

const demoPopup = () => {
  const launchButtons = [
    {
      id: "#launch-demo-one",
      src: "https://moarshath.weebly.com/",
    },
    {
      id: "#launch-demo-two",
      src: "https://moarshath.weebly.com/new-tab.html",
    },
    {
      id: "#launch-demo-three",
      src: "https://moarshath.weebly.com/button.html",
    },
    {
      id: "#launch-demo-four",
      src: "https://moarshath.weebly.com/embedded.html",
    },
  ];

  const popup = document.querySelector("#popup") as HTMLElement;
  const iframe = document.querySelector("#iframe") as HTMLIFrameElement;
  const terms = document.querySelector("#terms-close") as HTMLElement;
  let isClosed: boolean = false; // indicates the state of the popup

  const handleButtonClick = (src: string) => {
    if (iframe) {
      iframe.setAttribute("src", src);
      popup?.classList.add("active");
    } else {
      console.error("Error: iframe element not found");
    }
  };
  launchButtons.forEach((button) => {
    const launchButton = document.querySelector(button.id) as HTMLButtonElement;

    if (launchButton) {
      launchButton.addEventListener("click", () =>
        handleButtonClick(button.src)
      );
    }
  });

  if (terms) {
    terms.addEventListener("click", () => {
      if (!isClosed) {
        popup.classList.remove("active");
        isClosed = true;
      }
    });
  }

  return false;
};

const DemoPopup = ({ data }: DemoPopupProps) => {
  useEffect(() => {
    demoPopup();
  }, []);

  return (
    <div className="md:text-center">
      <a
        className="launch-demo btn-primary lg:py-1 md:mb-3 md:mt-5 md:w-100"
        id={data[0].id}
        onClick={demoPopup}
      >
        <span>{data[0].text}</span>
      </a>
      <a
        className="lg:ml-3 text-brandcolor text-smx"
        target="_blank"
        rel="noopener noreferrer"
        href={data[1].href}
      >
        {data[1].text}
      </a>
      <style jsx>{`
        .text-smx {
          vertical-align: middle;
        }
      `}</style>
    </div>
  );
};

export default DemoPopup;
